export const NANGO_SETTINGS_PATH = '/settings/integrations';
export const NANGO_INTEGRATION_SLUG = 'nango';
